module.exports = __webpack_public_path__ + "static/0066-920f4ef6b680d4ed321a7a4f234d0e66.png";